import { gql } from "@apollo/client";

export const PurchaseItems = gql`
  query PurchaseItems(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckPurchaseItemsOrder
    $name: String
  ) {
    PurchaseItems(
      token: $token
      after: $after
      first: $first
      customer_id: $customer_id
      orderBy: orderBy
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          addr
          email
          mobile
          c_person
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
